export const MISSING_EXPORT_SHIM_VARIABLE = '_missingExportShim';
